// src/api/services/applicationIncomeService.ts
import { ApplicationIncomeType, PayFrequency } from "../../types";
import api from "../axios";

export interface ApplicationIncomeDto {
  id: number;
  createdAt: string;
  type: ApplicationIncomeType;
  description: string;
  company: string;
  address?: string;
  phone?: string;
  jobTitle: string;
  monthlyNetIncome: number;
  startDate: string;
  endDate?: string;
  current: boolean;
  payFrequency?: PayFrequency;
}

export interface ApplicationIncomeInput {
  type: ApplicationIncomeType;
  description?: string;
  company: string;
  address?: string;
  phone?: string;
  jobTitle: string;
  monthlyNetIncome: number;
  startDate: string;
  endDate?: string;
  current: boolean;
  payFrequency?: PayFrequency;
}

export function getIncomeEntries(uuid: string) {
  return api.get<ApplicationIncomeDto[]>(`/applications/${uuid}/income`);
}

export function createIncomeEntry(uuid: string, data: ApplicationIncomeInput) {
  return api.post<ApplicationIncomeDto>(`/applications/${uuid}/income`, data);
}

export function updateIncomeEntry(
  uuid: string,
  incomeId: number,
  data: ApplicationIncomeInput
) {
  return api.put<ApplicationIncomeDto>(
    `/applications/${uuid}/income/${incomeId}`,
    data
  );
}

export function deleteIncomeEntry(uuid: string, incomeId: number) {
  return api.delete(`/applications/${uuid}/income/${incomeId}`);
}